import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccountExWithRoleRes } from '../../api/models';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  currentAccount: AccountExWithRoleRes | null = null;

  private subjectLoginDisplay = new BehaviorSubject<boolean>(false);
  private subjectAccountInfo = new BehaviorSubject<AccountExWithRoleRes | null>(null);

  constructor() {
    this.subjectLoginDisplay.next(false);
  }

  get getCurrentAD(): string | null {
    return localStorage.getItem('currentAD');
  }

  setLoginDisplay(loginDisplay: boolean) {
    this.subjectLoginDisplay.next(loginDisplay);
  }

  getLoginDisplay() {
    return this.subjectLoginDisplay.asObservable();
  }

  setAccount(account: AccountExWithRoleRes) {
    this.currentAccount = account;
    this.subjectAccountInfo.next(account);
  }

  getAccount() {
    return this.subjectAccountInfo.asObservable();
  }
}
